import type { FC, ReactNode } from 'react';

import styles from './Title.module.scss';
interface ITitle {
  name: string;
  children?: ReactNode;
}

const Title: FC<ITitle> = ({ name, children }) => {
  return (
    <div className={styles.titleContainer}>
      <h2 className={styles.titleText}>{name}</h2>
      {children}
    </div>
  );
};

export default Title;
